module.exports = __webpack_public_path__ + "img/org-default-banner-2.1a174b05.png";